import { FC } from 'react';

import { useRegistrationStore } from 'page/CustomerPage/hooks';
import { ConfirmationModalView } from 'page/CustomerPage/components/ConfirmationModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickRegistration: () => void;
};

export const ConfirmationModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickRegistration,
}) => {
  const {
    isOpenConfirmationModal,
    name,
    detail,
    environment,
    corporateNumber,
    channel,
    poseidonUrl,
    systemUpdateGroup,
    iapClientId,
    iapClientSecret,
    poseidonAgentCpu,
    poseidonAgentMemory,
    enableVerticalPodAutoScaler,
  } = useRegistrationStore();

  return (
    <>
      {/* 確認モーダル */}
      <ConfirmationModalView
        mode="登録"
        isOpen={isOpenConfirmationModal}
        name={name}
        detail={detail}
        environment={environment}
        corporateNumber={corporateNumber}
        channel={channel}
        poseidonUrl={poseidonUrl}
        systemUpdateGroup={systemUpdateGroup}
        iapClientId={iapClientId}
        iapClientSecret={iapClientSecret}
        poseidonAgentCpu={poseidonAgentCpu}
        poseidonAgentMemory={poseidonAgentMemory}
        enableVerticalPodAutoScaler={enableVerticalPodAutoScaler}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickExecution={handleClickRegistration}
      />
    </>
  );
};
